<div class="lfe-root">
  @if (debug) {
    <lfe-editor-toolbox
      [formGroup]="formGroup"
      (getLiveFormRequested)="getUpdatedLiveForm()"
      (getXmlRequested)="getFormItemsXml()"
      (getFormattedXmlRequested)="getFormItemsXml(true)" />
  }
  @for (item of filteredXmlItems(); track trackByItemId($index, item)) {
    <lfe-dynamic-form-item
      [xml]="item"
      [form]="formGroup"
      [user]="userInfo()"
      [settings]="settings()"
      [itemIndex]="$index"
      [isItemCreatedInCurrentSession]="isItemCreatedInSession"
      [sectionItemId]="getParentSectionOf(item)"
      [debug]="debug"
      [filteredXmlItems]="filteredXmlItems()"
      [filteredXmlItemsQty]="this.filteredXmlItems().length"
      [firstSiblingId]="getFirstSiblingId(item)"
      [sharedFirstColumnWidthsInput]="itemGroupFirstColumnWidths"
      [isReadonly]="formGroup.disabled"
      [orderId]="form().order.id"
      class="full-width"
      (addCommentRequested)="onAddComment($event)"
      (addPhotoCommentRequested)="onAddPhotoComment($event)"
      (deleteItemRequested)="onDeleteItem($event)"
      (resourceDataChanged)="onResourceDataChanged($event)"
      (repeatInstanceAddRequested)="onRepeatInstanceAdd($event)"
      (repeatInstanceDeleteRequested)="onRepeatInstanceDelete($event)"
      (updateFirstColumnWidth)="onUpdateFirstColumnWidth($event)">
    </lfe-dynamic-form-item>
  }
</div>
